<template>
  <div class="section">
    <!-- 주문 정보 -->
    <div class="order-info">
      <div class="order-info--tit">주문정보</div>
      <div class="order-info--row">
        <span class="label">주문 번호</span>
        <span class="value">{{ order.order_id }}</span>
      </div>
      <div class="order-info--row">
        <span class="label">배송 상태</span>
        <span class="value">{{ order.status_label }}</span>
      </div>
      <div v-if="order.package_company" class="order-info--row">
        <span class="label">운송장 번호</span>
        <span class="value">
          {{ order.package_company }} {{ order.invoice_number }}
          <button class="btn btn-grey" @click="openDelivery(order.delivery_url)">배송조회</button>
        </span>
      </div>
      <div class="order-info--row" style="padding: 0">
        <span class="label">상품</span>
        <div class="order-info--cards">
          <div v-for="(data, index) in order?.orderList" :key="index" class="order-info--card">
            <div class="name">[{{ data?.brand }}] {{ data?.product_name }}</div>
            <div class="option">
              <!-- {{ order }} -->
              옵션/수량 : {{ data?.label1 }}
              <span v-if="data?.label2">[ {{ data?.label2 }} ]</span> / {{ data?.inven }}개
            </div>
            <div class="price">{{ _formatAmount(data?.selling_price) }}원</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 주문 상품 정보 -->
    <!-- <div class="order-info">
      <div class="order-info--tit">주문 상품 정보</div>
      <div class="order-info--row">
        <span class="label">상품명</span>
        <span class="value">[{{ order.product_brand }}] 상품명</span>
      </div>
      <div class="order-info--row">
        <span class="label">가격</span>
        <span class="value">5,000원</span>
      </div>
      <div class="order-info--row">
        <span class="label">옵션</span>
        <span class="value">블루</span>
      </div>
      <div class="order-info--row">
        <span class="label">수량</span>
        <span class="value">5개</span>
      </div>
    </div> -->

    <!-- 배송지 정보 -->
    <div class="order-info">
      <div class="order-info--tit">배송지 정보</div>
      <div class="order-info--row">
        <span class="label">수령인</span>
        <span class="value">{{ order.name }}</span>
      </div>
      <div class="order-info--row">
        <span class="label">연락처</span>
        <span class="value">{{ order.phone }}</span>
      </div>
      <div class="order-info--row">
        <span class="label">주소</span>
        <span class="value">{{ order.address + ' ' + order.address2 }}</span>
      </div>
      <div class="order-info--row">
        <span class="label">배송 메시지</span>
        <span class="value">{{ order.delivery_message }}</span>
      </div>
    </div>

    <!-- 결제 정보 -->
    <div class="order-info">
      <div class="order-info--tit">결제 정보</div>
      <div class="order-info--row">
        <span class="label">상품 금액</span>
        <span class="value product-amount"
          >{{ _formatAmount(order.total_amount - order.delivery_charge) }} 원</span
        >
      </div>
      <div class="order-info--row">
        <span class="label">배송비</span>
        <span class="value shipping-fee">{{ _formatAmount(order.delivery_charge) }} 원</span>
      </div>
      <div class="order-info--row">
        <span class="label">총 결제금액</span>
        <span class="value total-amount">{{ _formatAmount(order.total_amount) }} 원</span>
      </div>
      <div class="order-info--row">
        <span class="label">결제 수단</span>
        <span class="value">카드</span>
      </div>
      <!-- <div class="order-info--row">
        <span class="label">결제 상태</span>
        <span class="value">{{ order.status_label }} </span>
      </div> -->
    </div>
  </div>
  <div v-show="order.market_delivery_status_id == 6" class="order-agree">
    <button class="btn btn-lg btn-grey" @click="cancelPayment">결제 취소하기</button>
  </div>
</template>

<script setup>
import Footer from '@/components/Footer.vue';
import { useRoute, useRouter } from 'vue-router';
import {
  _formatAmount,
  _getStorageWithExpiry,
  _setStorageWithExpiry,
  _getIsGonggu,
  _getPeriodStatus,
} from '../utils/common.js';
import api from '@/utils/api.js';
import { onMounted } from 'vue';

const order = JSON.parse(history.state.list);

onMounted(() => {
  window.scrollTo(0, 0);
  console.log(order);
});

const cancelPayment = async () => {
  const isConfirmed = window.confirm('정말 결제를 취소하시겠습니까?');
  if (!isConfirmed) return;

  const response = await api.post('/adm.php', {
    msg: '',
    mode: 'orderCancel',
    order_id: order.order_id,
    orderType: 'M',
  });

  if (response?.data?.result === 'SUCCESS') {
    alert('결제가 취소되었습니다.');
    history.back();
  } else {
    alert('결제 취소 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
  }
};

const openDelivery = url => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
</script>
